import React from 'react';
import { Order, Product } from '../MyOrders/MyOrders';

interface OrderTableProps {
  orders: Order[];
}

const OrderTable: React.FC<OrderTableProps> = ({ orders }) => {
  // const grandTotal = orders.reduce((total, order) => total + order.grand_total, 0);

  return (
    <div>
      <div className="relative overflow-x-auto" style={{ backgroundColor: 'transparent' }}>
        <table className="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
          <thead className="text-xs text-gray-700 uppercase dark:text-gray-400">
            <tr className='bg-[#75A7AD] text-white text-[16px] h-[65px]'>
              <th scope="col" className="px-6 py-3">Order Reference</th>
              <th scope="col" className="px-6 py-3">Product Name</th>
              <th scope="col" className="px-6 py-3">Quantity</th>
              <th scope="col" className="px-6 py-3">Total Price</th>
              <th scope="col" className="px-6 py-3">Status</th>
              <th scope="col" className="px-6 py-3">Order Type</th>
              <th scope="col" className="px-6 py-3">Date Ordered</th>
            </tr>
          </thead>
          <tbody>
            {orders.length > 0 ? (
              orders.flatMap(order =>
                Array.isArray(order.products) ? (
                  order.products.map((product: Product) => (
                    <tr key={order.id + '-' + product.product_id} className="">
                      <td className="px-6 py-4">{order.reference_number}</td>
                      <td className="px-6 py-4">{product.name}</td>
                      <td className="px-6 py-4">{product.quantity}</td>
                      <td className="px-6 py-4">{(product.price * product.quantity).toFixed(2)}</td>
                      <td className="px-6 py-4">{order.status}</td>
                      <td className="px-6 py-4">{product.order_type}</td>
                      <td className="px-6 py-4">{order.requested_ship_date ? new Date(order.requested_ship_date).toLocaleDateString() : 'N/A'}</td>
                    </tr>
                  ))
                ) : (
                  <tr key={order.id}>
                    <td colSpan={7} className="px-6 py-4 text-center">No products found for this order</td>
                  </tr>
                )
              )
            ) : (
              <tr>
                <td colSpan={7} className="px-6 py-4 text-center">No orders found</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default OrderTable;
